import {Tenant} from '@/shared/models';

const TENANT_URI = '/api/sadmin/tenant';
const TENANT_USER = '/api/sadmin/tenant/user';


export const TenantsApi = {
    async getTenants() {
        const response = await axios.get(`${TENANT_URI}s`);
        return response.data.content.map(d => new Tenant(d));
    },
    async createTenant(tenant) {
        const response = await axios.post(`${TENANT_URI}`, tenant);
        return new Tenant(response.data);
    },
    async addUserToTenant(tenantId,userId) {
        const response = await axios.post(`${TENANT_USER}?tenantId=`+tenantId+'&userId='+userId);
        return new Tenant(response.data);
    },
    async deleteUserFromTenant(tenantId,userId) {
        const response = await axios.delete(`${TENANT_USER}?tenantId=`+tenantId+'&userId='+userId);
        return new Tenant(response.data);
    }
};
